export enum FrequencyMode {
  DAY = "DAY",
  WEEK = "WEEK",
  MONTH = "MONTH",
}
